import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-carousel.css';

var getClassNameList = classNames.bind(styles);
var UitkCarouselItem = function (props) {
    var children = props.children, wrapItems = props.wrapItems, ariaHidden = props.ariaHidden, ariaLabel = props.ariaLabel, stretchToFill = props.stretchToFill;
    var itemRef = React.useRef(null);
    var baseClassName = 'uitk-carousel-item';
    if (!stretchToFill) {
        baseClassName += ' uitk-carousel-item-size-auto';
    }
    var toggleAriaHidden = function (item) {
        var itemClassName = wrapItems ? item.props.className : '';
        var itemProps = __assign(__assign({}, (ariaHidden && { 'aria-hidden': true, tabIndex: -1 })), { className: getClassNameList(itemClassName ? "".concat(itemClassName, " ").concat(baseClassName) : baseClassName), 'data-stid': 'carousel-item', 'aria-label': ariaLabel, ref: itemRef });
        if (!wrapItems) {
            return React.cloneElement(item, itemProps);
        }
        return React.createElement("div", __assign({}, itemProps), item);
    };
    var renderCarouselItem = function () {
        var item = children;
        return toggleAriaHidden(item);
    };
    return renderCarouselItem();
};
UitkCarouselItem.displayName = 'UitkCarouselItem';
UitkCarouselItem.defaultProps = {
    wrapItems: true
};

export { UitkCarouselItem };
